import { render } from "./Contact.vue?vue&type=template&id=2e148409"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e148409"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e148409', __exports__)) {
    api.reload('2e148409', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=2e148409", () => {
    api.rerender('2e148409', render)
  })

}


export default __exports__